import React, { PureComponent, Fragment } from "react";
import { connect } from "react-redux";
import { PropTypes } from "prop-types";
import { Segment, Button, Divider } from "semantic-ui-react";

import { ROW_STATE } from "../forms/formConstants.js";

import { selectCopy } from "../../state/reducers/locale/copySelector.js";

class SSHActions extends PureComponent {
  static propTypes = {
    showApplyExisting: PropTypes.bool.isRequired,
    showNotRequired: PropTypes.bool.isRequired,
    showActionsTop: PropTypes.bool.isRequired,
    skipped: PropTypes.bool.isRequired,
    push: PropTypes.func.isRequired,
    onSkip: PropTypes.func,
    onAdd: PropTypes.func,
    copyKey: PropTypes.string.isRequired,
    copy: PropTypes.func.isRequired
  };

  static defaultProps = {
    showInUse: false,
    showApplyExisting: true,
    showNotRequired: true,
    showActionsTop: false,
    copyKey: "ssh_keys"
  };

  render() {
    const {
      showApplyExisting,
      showNotRequired,
      skipped,
      push,
      onSkip,
      onAdd,
      copyKey,
      copy
    } = this.props;

    return (
      <Fragment>
        <Segment basic vertical>
          <div className="float-right">
            {showApplyExisting && (
              <Button
                onClick={() => onAdd(ROW_STATE.APPLY_EXISTING, push)}
                content={copy(`${copyKey}.add_existing_cta`)}
                icon="plus circle"
                type="button"
              />
            )}
            <Button
              onClick={() => onAdd(ROW_STATE.NEW, push)}
              content={copy(`${copyKey}.add_new_cta`)}
              icon="plus circle"
              type="button"
            />
            {!skipped && showNotRequired && (
              <Button
                onClick={() => onSkip()}
                content={copy(`${copyKey}.skip_cta`)}
                icon="times circle"
                type="button"
              />
            )}
          </div>
        </Segment>
        <Divider fitted clearing hidden />
      </Fragment>
    );
  }
}

const mapStateToProps = state => ({
  copy: selectCopy(state)
});

export default connect(mapStateToProps)(SSHActions);
